import { api } from './http';

export async function getClientContacts(clientId) {
  const response = await api.get(`/api/clients/${clientId}/contacts`);
  return response.data;
}

export async function addContactToClient(clientId, contactData) {
  const response = await api.post(`/api/clients/${clientId}/contacts`, contactData);
  return response.data;
}

export async function removeContactFromClient(clientId, contactId) {
  const response = await api.delete(`/api/clients/${clientId}/contacts/${contactId}`);
  return response.data;
}

export async function getContactsStats() {
  const response = await api.get('/api/clients/contacts/stats');
  return response.data;
}
